import React from "react";
import "./Home.css";
import icuhome from "../../assets/images/icuhome.png";
import icubed from "../../assets/images/icubed.png";
import { Link } from "react-router-dom";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export default function Icuservice({ homeSettings = {} }) {
  const homeIcuTitle =
    homeSettings.home_icu_title && homeSettings.home_icu_title.trim() !== ""
      ? homeSettings.home_icu_title
      : "Advanced ICU Setup At Home";
  const homeIcuDesc =
    homeSettings.home_icu_description &&
    homeSettings.home_icu_description.trim() !== ""
      ? homeSettings.home_icu_description
      : "Experience hospital-level critical care in the comfort of your home with our fully equipped ICU setup services.";
  const homeIcuLink =
    homeSettings.home_icu_link && homeSettings.home_icu_link.trim() !== ""
      ? homeSettings.home_icu_link
      : "/icu-installation-at-home";
  const homeIcuImg =
    homeSettings.home_icu_image && homeSettings.home_icu_image.trim() !== ""
      ? homeSettings.home_icu_image
      : icuhome;

  const hospIcuTitle =
    homeSettings.hospital_icu_title &&
    homeSettings.hospital_icu_title.trim() !== ""
      ? homeSettings.hospital_icu_title
      : "Advanced ICU Setup At Hospital";
  const hospIcuDesc =
    homeSettings.hospital_icu_description &&
    homeSettings.hospital_icu_description.trim() !== ""
      ? homeSettings.hospital_icu_description
      : "Experience hospital-level critical care in the comfort of your home with our fully equipped ICU setup services.";
  const hospIcuLink =
    homeSettings.hospital_icu_link &&
    homeSettings.hospital_icu_link.trim() !== ""
      ? homeSettings.hospital_icu_link
      : "/icu-installation-at-hospital";
  const hospIcuImg =
    homeSettings.hospital_icu_image &&
    homeSettings.hospital_icu_image.trim() !== ""
      ? homeSettings.hospital_icu_image
      : icubed;

  return (
    <div className="icuservice_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="icu-banner">
              <div className="content">
                <span className="offer-badge">25% Off</span>

                <h3>{homeIcuTitle}</h3>

                <p>{homeIcuDesc}</p>

                <button className="btn-book">
                  <Link to={homeIcuLink}>Book Now</Link>
                </button>
              </div>

              <div className="image">
                <img src={homeIcuImg} alt={homeIcuTitle} />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="small-icu-card">
              <div className="content">
                <h3>{hospIcuTitle}</h3>

                <p>{hospIcuDesc}</p>

                <button className="btn-book">
                  <Link to={hospIcuLink}>Book Now</Link>
                </button>
              </div>

              <img src={hospIcuImg} alt={hospIcuTitle} />
            </div>

            <div className="assessment-bar">
              <div className="assessment-icon">
                <AssignmentTurnedInIcon
                  style={{ fontSize: "20px", color: "white" }}
                />
              </div>

              <p>Complimentary Patient Assessment by Certified Caregiver</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
